export default function matchModel(model, obj) {
    let ret = {}
    for (const k in obj) {
        if (model.hasOwnProperty(k)) {
            ret[k] = obj[k]
        }
    }

    return ret
}
